
export default function Aprendizado() {
  const modules = [
    {
      icon: 'ri-brain-fill',
      title: 'Inteligência Artificial',
      description: 'Seu filho vai aprender sobre inteligência artificial, suas aplicações e como ela está transformando o mundo.',
      color: 'neon-blue',
      image: 'https://readdy.ai/api/search-image?query=holographic%20artificial%20intelligence%20interface%20with%20glowing%20blue%20neural%20networks%20and%20AI%20brain%20visualization%20floating%20in%20futuristic%20environment%20with%20neon%20lighting%20and%20digital%20data%20streams%20showing%20machine%20learning%20and%20AI%20technology%20concepts&width=600&height=400&seq=mod1ai&orientation=landscape'
    },
    {
      icon: 'ri-bit-coin-fill',
      title: 'Aprender sobre Bitcoin',
      description: 'Entender criptomoedas, blockchain e o futuro do dinheiro digital de forma simples e prática.',
      color: 'neon-purple',
      image: 'https://readdy.ai/api/search-image?query=holographic%20bitcoin%20cryptocurrency%20interface%20with%20glowing%20golden%20bitcoin%20symbols%20and%20blockchain%20network%20visualization%20floating%20in%20futuristic%20environment%20with%20purple%20neon%20lighting%20and%20digital%20currency%20data%20streams%20showing%20crypto%20technology&width=600&height=400&seq=mod2btc&orientation=landscape'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Como Ganhar Dinheiro Antes dos 20 Anos',
      description: 'Estratégias práticas para jovens empreenderem, criar renda e alcançar independência financeira cedo.',
      color: 'neon-pink',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20young%20entrepreneur%20workspace%20with%20holographic%20financial%20charts%20showing%20money%20growth%20and%20digital%20business%20success%20with%20pink%20and%20gold%20neon%20lighting%20floating%20dollar%20symbols%20and%20modern%20technology%20representing%20youth%20financial%20independence%20and%20early%20wealth%20creation&width=600&height=400&seq=mod3money&orientation=landscape'
    },
    {
      icon: 'ri-mic-fill',
      title: 'O Poder da Palavra – Comunicação, Persuasão e Oratória',
      description: 'Dominar a arte de falar em público, persuadir e se comunicar com confiança e impacto.',
      color: 'neon-blue',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20public%20speaking%20stage%20with%20holographic%20sound%20waves%20and%20communication%20symbols%20showing%20confident%20young%20speaker%20with%20blue%20neon%20lighting%20and%20floating%20speech%20bubbles%20representing%20persuasion%20and%20powerful%20oratory%20skills%20in%20modern%20presentation%20environment&width=600&height=400&seq=mod4speech&orientation=landscape'
    },
    {
      icon: 'ri-compass-3-fill',
      title: 'Projeto de Vida – Quem você quer ser quando crescer?',
      description: 'Descobrir propósito, definir metas e criar um plano de vida para alcançar seus sonhos e objetivos.',
      color: 'neon-purple',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20life%20planning%20interface%20with%20holographic%20compass%20and%20glowing%20purple%20pathways%20showing%20young%20person%20journey%20to%20success%20with%20floating%20goal%20symbols%20career%20options%20and%20dream%20visualization%20in%20inspiring%20motivational%20environment%20representing%20life%20purpose%20and%20future%20aspirations&width=600&height=400&seq=mod5lifeproject&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-fill',
      title: 'Corpo, Mente, Espírito e Superação Pessoal',
      description: 'Desenvolver equilíbrio físico, mental e espiritual para superar desafios e alcançar seu máximo potencial.',
      color: 'neon-pink',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20holographic%20meditation%20scene%20with%20young%20person%20in%20balanced%20pose%20surrounded%20by%20glowing%20pink%20and%20purple%20energy%20showing%20body%20mind%20and%20spirit%20harmony%20with%20floating%20wellness%20symbols%20health%20icons%20and%20spiritual%20growth%20visualization%20in%20peaceful%20inspiring%20environment%20representing%20personal%20development%20and%20self%20improvement&width=600&height=400&seq=mod6wellness&orientation=landscape'
    },
    {
      icon: 'ri-chess-fill',
      title: 'Xadrez – Estratégia e Raciocínio Lógico',
      description: 'Desenvolver pensamento estratégico, concentração e habilidades de tomada de decisão através do xadrez.',
      color: 'neon-blue',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20holographic%20chess%20board%20with%20glowing%20blue%20neon%20pieces%20floating%20in%20digital%20space%20showing%20strategic%20thinking%20and%20logical%20reasoning%20with%20young%20player%20analyzing%20moves%20surrounded%20by%20tactical%20patterns%20and%20decision-making%20visualization%20in%20modern%20gaming%20environment%20representing%20intelligence%20and%20strategy%20development&width=600&height=400&seq=mod7chess&orientation=landscape'
    },
    {
      icon: 'ri-box-3-fill',
      title: 'Cubo Mágico – Agilidade Mental',
      description: 'Aprimorar coordenação motora, memória espacial e velocidade de raciocínio resolvendo o cubo mágico.',
      color: 'neon-purple',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20holographic%20rubiks%20cube%20with%20glowing%20purple%20and%20multicolor%20neon%20sides%20floating%20and%20rotating%20in%20digital%20space%20showing%20mental%20agility%20and%20problem%20solving%20with%20young%20person%20hands%20manipulating%20cube%20surrounded%20by%20speed%20patterns%20and%20spatial%20memory%20visualization%20representing%20cognitive%20development%20and%20quick%20thinking%20skills&width=600&height=400&seq=mod8cube&orientation=landscape'
    },
    {
      icon: 'ri-brain-fill',
      title: 'Técnicas de Memória e Concentração',
      description: 'Aprender métodos comprovados para melhorar memória, foco e capacidade de aprendizado acelerado.',
      color: 'neon-pink',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20holographic%20brain%20with%20glowing%20pink%20neural%20connections%20and%20memory%20pathways%20showing%20young%20person%20learning%20with%20floating%20information%20symbols%20concentration%20icons%20and%20mental%20focus%20visualization%20in%20inspiring%20environment%20representing%20memory%20enhancement%20cognitive%20improvement%20and%20accelerated%20learning%20techniques&width=600&height=400&seq=mod9memory&orientation=landscape'
    }
  ];

  return (
    <section className="relative py-16 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-20 space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-blue/10 border border-neon-blue/30 backdrop-blur-sm">
              <i className="ri-lightbulb-flash-fill text-neon-blue text-sm md:text-base"></i>
              <span className="text-neon-blue text-xs md:text-sm font-semibold tracking-wide">A SOLUÇÃO</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight max-w-4xl mx-auto px-4">
              O Que Seu Filho Vai
              <span className="block bg-gradient-to-r from-neon-blue via-neon-purple to-neon-pink bg-clip-text text-transparent mt-2"> Aprender</span>
            </h2>

            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              São 9 cursos independentes, cada um referente a uma grande habilidade do futuro. Você pode matricular seu filho em apenas um dos cursos à sua escolha, ou no curso completo que engloba todas as habilidades, e pra quem fizer o curso completo, ganha 6 bônus.
            </p>
          </div>

          {/* Modules Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {modules.map((module, index) => (
              <div 
                key={index}
                className="group relative bg-dark-800/50 backdrop-blur-sm border border-neon-blue/20 rounded-2xl md:rounded-3xl overflow-hidden hover:border-neon-blue/50 transition-all duration-500 hover:shadow-[0_0_40px_rgba(0,212,255,0.3)] hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-40 md:h-48 overflow-hidden">
                  <img 
                    src={module.image}
                    alt={module.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t from-dark-800 via-dark-800/50 to-transparent`}></div>
                  
                  {/* Icon */}
                  <div className={`absolute top-3 md:top-4 right-3 md:right-4 w-12 h-12 md:w-14 md:h-14 bg-${module.color}/20 backdrop-blur-md rounded-lg md:rounded-xl border border-${module.color}/40 flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${module.icon} text-xl md:text-2xl text-${module.color}`}></i>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4 md:p-6 space-y-2 md:space-y-3">
                  <h3 className="text-lg md:text-2xl font-bold text-white group-hover:text-neon-blue transition-colors duration-300 leading-tight">
                    {module.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                    {module.description}
                  </p>
                </div>

                {/* Hover Glow Effect */}
                <div className={`absolute inset-0 bg-gradient-to-t from-${module.color}/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}